/**
 * @module lib/commercial/keytar/cannabis-sponsored-content
 */
import template from "./template";
import Wall from "lib/commercial/keytar/Wall";
import { WALL_TYPES } from "lib/commercial/keytar/WallAnalyticsSchema";
import logger from "utils/logger";
import { getIsConfirmed } from "./pages";

const name = "cannabisSponsoredWall";
const debugTag = `[KEYTAR] ${name}`;

const rules = [{
  /** @returns {Boolean} true when access is allowed for user */
  accessAllowed() {
    const isConfirmed = getIsConfirmed();
    logger.info(`${debugTag} is confirmed: ${isConfirmed}`);
    return isConfirmed;
  },
  /** @returns {Boolean} true when wall should be used for article page */
  matcher({ url }) {
    // note the lack of a /g flag here: implementing it may cause /re/.test(str) to do weird things
    // see http://2ality.com/2013/08/regexp-g.html for more info
    const re = /.*?\/cannabis\/(adv|gated)\/([\w\-]+\/)*(article|gallery|video)+([\w\-]+)\/*/im;

    // Second condition is backdoor to force Age Gate to show up for testing purposes.
    return re.test(url) || /ageGate=true/im.test(window.location.search);
  },
  /** @type {String} */
  name: name
}];

const props = {
  rules,
  featureFlagName: `${name}Enabled`, // defined in environment-variables.jsp
  template
};

export default new Wall("cannabis-sponsored-content", WALL_TYPES.AGEWALL_HARD, props);
